import styled from "styled-components";

import {
  borderRadius,
  boxShadowColor,
  lightColor,
  secondaryColor,
  primaryColor,
} from "../variables.styles";

export const ResourceContainer = styled.div`
  background: ${secondaryColor};
  padding: 2rem;

  h2 {
    text-align: center;
    padding: 2rem;
    text-transform: uppercase;
    font-weight: bold;
    color: ${lightColor};

    @media (min-width: 800px) {
      grid-column: 1 / -1;
    }
  }

  @media (min-width: 800px) {
    display: grid;
    grid-template-columns: repeat(2, 400px);
    grid-gap: 3rem;
    margin: 0 auto;
    place-content: center;
  }
`;

export const ResourceCard = styled.div`
  box-shadow: 0 0 3px 2px ${boxShadowColor};
  background: ${lightColor};
  width: 400px;
  border-radius: ${borderRadius};
  margin: auto;

  img {
    width: 400px;
    height: 200px;
    background: linear-gradient(to left, ${primaryColor}, ${secondaryColor});
    object-fit: cover;
    border-top-left-radius: ${borderRadius};
    border-top-right-radius: ${borderRadius};
  }
  p,
  h3 {
    padding: 1rem 2rem;
  }
  h3 {
    font-weight: bold;
    font-size: 1.7rem;
  }
  p {
    color: rgb(0, 0, 0, 0.5);
    font-size: 1.5rem;
  }
`;
